import { DEFAULT_EXACTMATCH } from "@/common/consts";

import i18n from "@/common/multilanguage/i18n";

export default {
	/** The current language locale, based on route. */
	currentLanguage: i18n.locale,
	countryCode: null,

	/* Items relating to measurements of the window or DOM elements */
	window: {
		windowHeight: null,
		windowWidth: null,
		scrollY: null,
		/*
        This is the pixel height between the top of the window and
        the bottom of the header. I.e., if the header is scrolled out of view, this value is 0.
        */
		visibleHeaderHeight: null,
		topAdHeight: 0,
		headerHeight: 0,
		smartBannerHeight: 0,
		searchHeaderMobileHeight: 0,
	},
	/** Navigation related state */
	navigation: {
		/** Burger Button state. 'true' will show the navigation on small
		 * devices
		 */
		burgerActive: false,

		/** Current $route.name */
		current: "",
	},
	status: {
		/**
		 * Is the App performing some asynchronous call at this moment?
		 */
		loading: false,

		/**
		 * Did the asynchronous call result in some kind of server/application
		 * error?
		 */
		error: false,

		/**
		 * Is this a second query? (On certain games, when the first query returns 0 results, a second query is automatically initiated with a wildcare prepended to the first query's tiles)
		 */
		secondQuery: false,

		/**
		 * Is the user just landing on the current page? We can load only what is absolutely necessary for an improved landing experience.
		 */
		justLanding: true,
	},
	/** Unscrambler-like query related state */
	query: {
		/** The tiles from user input (either from Finder or URL).
		 * Possibly alphabetised depending on requirement.
		 */
		tiles: "",
		/** The original tiles from user input (either from Finder or URL).
		 * Sanitized, but not alphabetized
		 */
		unsortedTiles: "",

		/** The tiles used to automatically find alternatives based on the original user input
		 */
		prefixedTiles: "",

		/**
		 * Boolean flag binded to SCRABBLE_DICTIONARY "exact match" option checkbox
		 */
		exact: DEFAULT_EXACTMATCH,

		/**
		 * Integer value binded to FOURPICS word length select
		 */
		wordlength: null,

		/**
		 * String value for the advanced search option 'Starts With'
		 */
		startsWith: "",

		/**
		 * String value for the advanced search option 'Ends With'
		 */
		endsWith: "",

		/**
		 * String value for the advanced search option 'Contains'
		 */
		contains: "",

		/**
		 * String value that contains dictionary name or game name
		 */
		dictionary: null,

		/**
		 * String value that contains sorting name
		 */
		sortResults: null,

		/**
		 * Boolean value that contains results should be filtered with bonus points or not
		 */
		bonuspoints: false,

		/**
		 * Array with checked digraphs
		 */
		checkedDigraphs: [],
		/**
		 * Flags any focused advanced search field individually
		 */
		focusedAdvanceFields: {
			startsWith: false,
			contains: false,
			endsWith: false,
			wordLength: false,
		},
		/**
		 * String value describing the criteria by which we want to result entries to be ordered
		 */
		orderBy: "score",
	},

	/** Unscrambler-like query results */
	results: {
		/**
		 * Raw API response items are stored in words array
		 */
		words: [],

		/**
		 * Total results count from the API response. It accounts for all different words returned as flat items, groups and exact_match.
		 */
		resultsCount: 0,

		/**
		 * If user input is an actual word in `words`, match will contain this
		 * same word.
		 */
		match: "",
	},
	/** AB experimentation data */
	experiments: {
		/**
		 * String value for the experiment channel. Valid values: 'A','B','C','D'
		 */
		channel: null,
		/**
		 * Override value for the experiment channel. Used for per-page overrides. Valid values same as above.
		 */
		overrideChannel: null,
		/**
		 * The date version string for the channel. Format: 'YYMMDD'
		 */
		date: null,
	},
	/** The height of the search container in finder component */
	finderHeight: 0,
	lastVisited: null,
	/**
	 * The List of saved words, (Saved by clicking save word option from the result table)
	 */
	savedWords: [],
	/**
	 * The list of API-returned words, grouped per table.
	 */
	words: {},
	augmentedResults: {},
	augmentedResultsTiles: "",
	relatedLists: [],
	user: {
		/**
		 * A usual user is someone who, at some point, has spent more than 1 minute on the site (as opposed to the default casual user).
		 * This information is saved in a cookie and is loaded on each application load.
		 */
		isUsualUser: false,
	},
	/**
	 * An object holding information about opened modals
	 */
	openedModals: {},
	/**
	 * Flag set to true when the loading of the saved words is in progress.
	 */
	loadingSavedWords: false,
	searchAgain: false,
};
